import React from 'react';
import { IExternalLInkListProps } from '../../interfaces/ExternalLinkProps';
import ExternalLinkItem from './ExternalLinkItem';

/**
 * A component to generate a list of external links, like websites.
 * @param externalLinks
 */
const ExternalLinkList = ({ externalLinks }: IExternalLInkListProps): JSX.Element | null => {
  if (externalLinks && externalLinks.length > 0) {
    if (externalLinks.length === 1) {
      return (
        <ExternalLinkItem key={externalLinks[0].Tekst} externalLink={externalLinks[0].Tekst} />
      );
    }
    return (
      <ul>
        { externalLinks.map((externalLink) => <li key={externalLink.Tekst}><ExternalLinkItem externalLink={externalLink.Tekst} /></li>)}
      </ul>
    );
  }

  return null;
};

export default ExternalLinkList;
